<template>
  <div>
    <button class="btn btn-info mb-2" @click.prevent="openItemModal" v-if="hoso_update">
      <i class="fas fa-plus"></i>
      Add
      <!-- Thêm -->
    </button>
    <b-table bordered head-variant="dark" hover responsive :fields="fields" :items="items" table-variant="light">
      <template v-slot:cell(tenkhoadaotao)="data" v-if="hoso_update">
        <b-link href="#" @click.prevent="openUpdateItemModal(data)">{{data.value}}</b-link>
      </template>
      <template
        v-slot:cell(ngaybatdau)="data"
      >{{data.item.ngaybatdau | moment('DD/MM/YYYY')}}</template>
      <template v-slot:cell(ngayketthuc)="data">{{data.item.ngayketthuc | moment('DD/MM/YYYY')}}</template>
      <template v-slot:cell(hocphi)="data">{{formatPrice(data.value)}}</template>
      <template v-slot:cell(congtytaitro)="data">{{formatPrice(data.value)}}</template>
      <template v-slot:cell(action)="data" v-if="hoso_update">
        <b-link class="text-danger" href="#" @click.prevent="deleteItem(data)">
          <i class="fas fa-trash"></i>
        </b-link>
      </template>
    </b-table>
    <b-modal
      v-model="modalShow"
      header-bg-variant="info"
      header-text-variant="light"
      size="xl"
       hide-footer
    >
      <template v-slot:modal-title>
        <div v-if="item_selected.id <= 0">
          Add Training Course
          <!-- Thêm khóa đào tạo -->
        </div>
        <div v-else>
          Update Training Course
          <!-- Cập nhật khóa đào tạo -->
        </div>
      </template>
      <b-form class="mr-4" autocomplete="off" @submit="ok()">
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">
              Training Course
              <!-- Tên khóa đào tạo -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="9">
            <b-form-input v-model="item_selected.tenkhoadaotao" required></b-form-input>
          </b-col>
        </b-form-row>
        <!-- <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">Mã khóa đào tạo</label>
          </b-col>
          <b-col cols="9">
            <b-form-input v-model="item_selected.makhoadaotao" required></b-form-input>
          </b-col>
        </b-form-row> -->
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">
              Start date
              <!-- Ngày bắt đầu -->
            </label>
          </b-col>
          <b-col cols="3">
            <vue-datepicker-local style="width: 100%"
              v-model="item_selected.ngaybatdau"
              :local="local"
              clearable
              format="DD/MM/YYYY"
            />
          </b-col>
          <b-col cols="1"></b-col>
          <b-col cols="2">
            <label class="mr-2">
              End date
              <!-- Ngày kết thúc -->
            </label>
          </b-col>
          <b-col cols="3">
            <vue-datepicker-local style="width: 100%"
              v-model="item_selected.ngayketthuc"
              :local="local"
              clearable
              format="DD/MM/YYYY"
            />
          </b-col>
        </b-form-row>
        <!-- <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">Tên chứng chỉ</label>
          </b-col>
          <b-col cols="9">
            <b-form-input v-model="item_selected.tenchungchi" required></b-form-input>
          </b-col>
        </b-form-row> -->

        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">
              Training Fee
              <!-- Học phí -->
            </label>
          </b-col>
          <b-col cols="3">
            <my-currency-input v-model="item_selected.hocphi" />
          </b-col>
          <b-col cols="1"></b-col>
          <b-col cols="2">
            <label class="mr-2">
              Sponsored by
              <!-- Công ty tài trợ -->
            </label>
          </b-col>
          <b-col cols="3">
            <my-currency-input v-model="item_selected.congtytaitro" />
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">
              Result
              <!-- Kết quả -->
            </label>
          </b-col>
          <b-col cols="9">
            <b-form-input v-model="item_selected.ketqua" required></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">
              Feedback
              <!-- Nhận xét -->
            </label>
          </b-col>
          <b-col cols="9">
            <b-form-input v-model="item_selected.nhanxet" required></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-3">
          <b-col cols="11" class="form-inline">
            <div style="flex-grow: 1"></div>
            <b-button class="mr-3" variant="info" @click.prevent="storeItem">
              <i class="fas fa-save mr-2"></i>
              Save
              <!-- Lưu -->
            </b-button>
            <b-button variant="secondary" @click="closeItemModal">
              <i class="fas fa-times mr-2"></i>
              Close
              <!-- Đóng -->
            </b-button>
          </b-col>
        </b-form-row>
        <!-- <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">Ghi chú</label>
          </b-col>
          <b-col cols="9">
            <b-form-textarea v-model="item_selected.ghichu" rows="2"></b-form-textarea>
          </b-col>
        </b-form-row> -->
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";
import MyCurrencyInput from "../App/MyCurrencyInput";
export default {
  name: "QuaTrinhDaoTao",
  props: ["item"],
  components: {
    VueDatepickerLocal,
    MyCurrencyInput
  },
  data() {
    return {
      modalShow: false,
      items: [],
      itemIdex: null,
      fields: [
        {
          key: "tenkhoadaotao",
          label: "Training Course",
          // label: "Tên khóa đào tạo",
        },
        // {
        //   key: "makhoadaotao",
        //   label: "Mã khóa đào tạo",
        // },
        {
          key: "ngaybatdau",
          label: "Start date",
          // label: "Ngày bắt đầu",
        },
        {
          key: "ngayketthuc",
          label: "End date",
          // label: "Ngày kết thúc",
        },
        // {
        //   key: "tenchungchi",
        //   label: "Tên chứng chỉ",
        // },
        {
          key: "ketqua",
          label: "Result",
          // label: "Kết quả",
        },
        {
          key: "hocphi",
          label: "Training Fee",
          // label: "Học phí",
        },
        {
          key: "congtytaitro",
          label: "Sponsored by",
          // label: "Công ty tài trợ",
        },
        {
          key: "nhanxet",
          label: "Feedback",
          // label: "Nhận xét",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "50px !important" },
        },
      ],
      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },
      item_null: {
        id: 0,
        employeeid: 0,
        tenkhoadaotao: null,
        ngaybatdau: null,
        ngayketthuc: null,
        ketqua: null,
        hocphi: 0,
        congtytaitro: 0,
        nhanxet: null,
      },
      item_selected: {
        id: 0,
        employeeid: 0,
        tenkhoadaotao: null,
        ngaybatdau: null,
        ngayketthuc: null,
        ketqua: null,
        hocphi: 0,
        congtytaitro: 0,
        nhanxet: null,
      },
    };
  },
  computed: {
    hoso_update() {
      return this.$store.getters.hasPermission("hoso_update");
    },
  },
  created() {
    if (this.item != null) this.initData();
  },
  methods: {
    formatPrice(value) {
      let val = value / 1;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    initData() {
      axios
        .get(`/api/employeetraining/${this.item.id}`)
        .then((response) => {
          this.items = response.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },
    openItemModal() {
      this.item_selected = JSON.parse(JSON.stringify(this.item_null));
      this.item_selected.employeeid = this.item.id;
      this.modalShow = true;
    },
    openUpdateItemModal(data) {
      this.item_selected = JSON.parse(JSON.stringify(data.item));
      this.itemIdex = data.index;
      this.modalShow = true;
    },
    closeItemModal() {
      this.modalShow = false;
    },
    storeItem(bvModalEvt) {
      if (
        !(
          this.item_selected.tenkhoadaotao &&
          this.item_selected.tenkhoadaotao.length
        )
      ) {
        this.$toast.error("Please input full information", "Error", {
          timeout: 2000,
        });
        bvModalEvt.preventDefault();
      } else {
        if (this.item_selected.id <= 0) {
          axios
            .post("/api/employeetraining", this.item_selected)
            .then((res) => {
              this.modalShow = false;
              this.items.push(res.data);
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Error", { timeout: 3000 });
            });
        } else {
          axios
            .put("/api/employeetraining", this.item_selected)
            .then((res) => {
              this.modalShow = false;
              this.items[this.itemIdex] = JSON.parse(
                JSON.stringify(this.item_selected)
              );
              const temp = JSON.parse(JSON.stringify(this.items));
              this.items = JSON.parse(JSON.stringify(temp));
              this.itemIdex = null;
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Error", { timeout: 3000 });
            });
        }
      }
    },
    deleteItem(data) {
      this.$toast.question("BDo you really want to delete?", "Warning", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/employeetraining/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Delete successfully", "Success", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Error", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
